import Yup from 'utils/validation/yup-extensions';

/**
 * Form property keys.
 * @type {Object}
 */
export const FORM_KEYS = {
	ORGANIZATION_NAME: 'ORGANIZATION_NAME',
};

/**
 * Default Formik form initial value object.
 * @type {Object}
 */
export let FORM_INITIAL_VALUES = {
	[FORM_KEYS.ORGANIZATION_NAME]: '',
};

export const VALIDATION_PATTERNS = {
	[FORM_KEYS.ORGANIZATION_NAME]: "^[\\w\\(\\)'\\.\\-&, ]*$",
};

/**
 * Minimum string comparison threshold to be considered "similar".
 * @type {number}
 */
export const MINIMUM_SIMILARITY = 0.6;

/**
 * Minimum accepted number of characters.
 * @type {number}
 */
export const MINIMUM_LENGTH = 2;
export const VALIDATION_MESSAGE = 'Field is required.';

/**
 * Default Formik form Yup validation schema logic object.
 * @type {Object}
 */
export const FORM_VALIDATION_SCHEMA_OBJECT = {
	[FORM_KEYS.ORGANIZATION_NAME]: Yup.string()
		.required(VALIDATION_MESSAGE)
		.min(MINIMUM_LENGTH, 'Too few characters.')
		.matches(new RegExp(VALIDATION_PATTERNS[FORM_KEYS.ORGANIZATION_NAME]), {
			message: 'Invalid special characters.',
		}),
};
